module.exports = __webpack_public_path__ + "public/hws/images/background_login.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/background_login.jpg
// module id = 315
// module chunks = 0